"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(event) {
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  event.persist();
  Object.keys(overrides).forEach(function (key) {
    Object.defineProperty(event.target, key, {
      writable: true,
      value: overrides[key]
    });
  });
  return event;
};

exports["default"] = _default;